module.exports = __webpack_public_path__ + "assets/img/drumsticks.f503d417.png";